import createPlugin from './createPlugin';
import DividerHtmlRenderer from './Renderer/DividerHtmlRenderer';
var plugin = createPlugin({
    Renderer: DividerHtmlRenderer,
});
export default plugin;
//# sourceMappingURL=index.js.map